import Vue from 'vue'
import VueResource from 'vue-resource'
import authService from 'service/authService'
import translateMsg from 'service/translateMsg'
// import config from 'config'
import qs from 'qs'
import dm from 'kkt-domain'
// import './mock'

// use
Vue.use(VueResource)

// http 全局设置
// Vue.http.options.root = '/api'

// http 管道处理函数
Vue.http.interceptors.push(function (req, next) {
  // 跨域请求url替换
  if (req.url.indexOf('@') === 0) {
    if (!req.url.match(/@[^\\/]+/ig)) {
      req.url = req.url.replace('@', dm.get())
    } else {
      req.url = dm.replaceAt(req.url)
    }
  }

  // CORS 跨域请求支持
  if (req.url.indexOf('http') === 0) {
    req.credentials = true
    req.headers.set('Content-Type', 'application/x-www-form-urlencoded')
    req.headers.set('X-Requested-With', 'XMLHttpRequest')
    req.body = qs.stringify(req.body)
  }

  next(function (res) {
    // 处理业务状态码
    if (res.body.code) {
      res.body.code = parseInt(res.body.code)
    }

    // 处理登录状态
    if (res.status === 401 || res.body.code === 3002) {
      var router = require('../router').default
      if (authService.isLoggedIn()) {
        // 已登录的跳转到没有权限页面
        return authService.noPriv()
      } else if (router.currentRoute.matched && router.currentRoute.matched.matched.some(route => route.meta.requireAuth)) {
        // 未登录的跳转到登录页面
        return authService.login()
      }
    }

    // 记录系统错误日志
    if (res.status !== 200) {
      window._hmt.push(['_trackEvent', '系统错误', res.status, 'api', res.url])
    }

    // 记录业务错误日志
    if (res.body.code !== 2000 && res.body.code !== 3002) {
      window._hmt.push(['_trackEvent', '业务错误', res.body.code, 'api', res.url])
    }

    // 处理消息转换
    if (typeof res.body.msg === 'string') {
      res.body.msg = translateMsg(res.body.msg)
    }
  })
})

export default Vue.http



// WEBPACK FOOTER //
// ./src/api/index.js